import i18next from 'i18next';

i18next.addResources('es', 'countrySelector', {
  allCountries: 'Todos los países',
  countries: 'País',
  argentina: 'Argentina',
  bolivia: 'Bolivia',
  brasil: 'Brasil',
  chile: 'Chile',
  colombia: 'Colombia',
  ecuador: 'Ecuador',
  bahamas: 'Bahamas',
  barbados: 'Barbados',
  belice: 'Belice',
  costa_rica: 'Costa Rica', // eslint-disable-line camelcase
  el_salvador: 'El Salvador', // eslint-disable-line camelcase
  guatemala: 'Guatemala',
  guyana: 'Guyana',
  french_guiana: 'Guyana Francesa',
  haiti: 'Haití',
  honduras: 'Honduras',
  jamaica: 'Jamaica',
  mexico: 'México',
  nicaragua: 'Nicaragua',
  panama: 'Panamá',
  paraguay: 'Paraguay',
  peru: 'Perú',
  dominican_republic: 'República Dominicana', // eslint-disable-line camelcase
  suriname: 'Suriname',
  trinidad_and_tobago: 'Trinidad y Tobago', // eslint-disable-line camelcase
  uruguay: 'Uruguay',
  venezuela: 'Venezuela',
  africa: 'África',
  north_america: 'América del Norte', // eslint-disable-line camelcase
  antartic: 'Antártida',
  asia: 'Asia',
  europe: 'Europa',
  oceania: 'Oceanía',
  belize: 'Belize'
});

i18next.addResources('en', 'countrySelector', {
  allCountries: 'All countries',
  countries: 'Country',
  argentina: 'Argentina',
  bolivia: 'Bolivia',
  brasil: 'Brazil',
  chile: 'Chile',
  colombia: 'Colombia',
  ecuador: 'Ecuador',
  bahamas: 'Bahamas',
  barbados: 'Barbados',
  belice: 'Belize',
  costa_rica: 'Costa Rica', // eslint-disable-line camelcase
  el_salvador: 'El Salvador', // eslint-disable-line camelcase
  guatemala: 'Guatemala',
  guyana: 'Guyana',
  french_guiana: 'French Guiana',
  haiti: 'Haiti',
  honduras: 'Honduras',
  jamaica: 'Jamaica',
  mexico: 'Mexico',
  nicaragua: 'Nicaragua',
  panama: 'Panama',
  paraguay: 'Paraguay',
  peru: 'Peru',
  dominican_republic: 'Dominican Republic', // eslint-disable-line camelcase
  suriname: 'Suriname',
  trinidad_and_tobago: 'Trinidad and Tobago', // eslint-disable-line camelcase
  uruguay: 'Uruguay',
  venezuela: 'Venezuela',
  africa: 'Africa',
  north_america: 'North America', // eslint-disable-line camelcase
  antartic: 'Antarctica',
  asia: 'Asia',
  europe: 'Europe',
  oceania: 'Oceania',
  belize: 'Belize'
});

i18next.addResources('pt', 'countrySelector', {
  allCountries: 'Todos os países',
  countries: 'País',
  argentina: 'Argentina',
  bolivia: 'Bolívia',
  brasil: 'Brasil',
  chile: 'Chile',
  colombia: 'Colômbia',
  ecuador: 'Equador',
  bahamas: 'Bahamas',
  barbados: 'Barbados',
  belice: 'Belize',
  costa_rica: 'Costa Rica', // eslint-disable-line camelcase
  el_salvador: 'El Salvador', // eslint-disable-line camelcase
  guatemala: 'Guatemala',
  guyana: 'Guiana',
  french_guiana: 'Guiana Francesa',
  haiti: 'Haiti',
  honduras: 'Honduras',
  jamaica: 'Jamaica',
  mexico: 'México',
  nicaragua: 'Nicarágua',
  panama: 'Panamá',
  paraguay: 'Paraguai',
  peru: 'Peru',
  dominican_republic: 'República Dominicana', // eslint-disable-line camelcase
  suriname: 'Suriname',
  trinidad_and_tobago: 'Trinidad e Tobago', // eslint-disable-line camelcase
  uruguay: 'Uruguai',
  venezuela: 'Venezuela',
  africa: 'África',
  north_america: 'América do Norte', // eslint-disable-line camelcase
  antartic: 'Antártida',
  asia: 'Ásia',
  europe: 'Europa',
  oceania: 'Oceania',
  belize: 'Belize'
});
